import { useState } from "react";
import { Wrapper } from "nystem-components";
import app from "nystem";

const SelectCheckbox = ({ model, value, setValue }) => {
  const [id] = useState(app.uuid);
  const { text, field, limit, className, classNameLabel, disabled } = model;

  const handleChange = (id) => {
    const newValue = value instanceof Array ? [...value] : value || [];

    if (id === "") id = undefined;
    if (newValue.indexOf(id) !== -1) newValue.splice(newValue.indexOf(id), 1);
    else newValue.push(id);

    if (limit && limit < newValue.length) newValue.shift();

    if (limit === 1) setValue(newValue[0]);
    else setValue(newValue);
  };

  return (
    <Wrapper renderAs="label" className={className} htmlFor={id}>
      <input
        id={id}
        onChange={() => handleChange(field)}
        type="checkbox"
        checked={value?.indexOf(field) !== -1 || disabled ? "checked" : false}
        className={classNameLabel}
        disabled={model.disabled}
      />
      {app.t(text)}
    </Wrapper>
  );
};

export default SelectCheckbox;
